import React, { useContext, useEffect } from "react";
import AttributeRights from "./AttributeRights";
import PageRights from "./PageRights";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import OthersRights from "./OthersRights";
import Scrollable from "../Shared/Edit/Scrollable";
import { RoleContext } from "./Context/RoleContext";
import useInternalUserCheck from "../../Hooks/Misc/useInternalUserCheck";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Renderers/GlobalContext";

function RightsBasedOnEntity(props) {
	const { state, dispatch } = useContext(RoleContext);
	const { organization, user } = useContext(GlobalContext).state;
	const isInternalUser = useInternalUserCheck(user.email);
	const handleTabs = (e) => {
		dispatch({ type: "SET_SELECTED_ENTITY_RIGHTS_TAB", payload: e.selected });
	};

	const { t, i18n } = useTranslation([
		"role/common"
	], {
		useSuspense: false
	});

	useEffect(() => {
		// i18n.changeLanguage(organization.platformLanguage)
	}, [])

	return (
		<TabStrip
			animation={false}
			className="custom-tab-white h-100"
			selected={state.selectedEntityRightsTab}
			onSelect={handleTabs}
		>
			<TabStripTab title={t("role_object_rights_tabs.properties_tab")}>
				<Scrollable>
					<AttributeRights {...props} organization={organization} />
				</Scrollable>
			</TabStripTab>
			{isInternalUser && state.advancedMode && (
				<TabStripTab title={t("role_object_rights_tabs.display_pages_tab")}>
					<Scrollable>
						<PageRights {...props} organization={organization} />
					</Scrollable>
				</TabStripTab>
			)}
			{isInternalUser && state.advancedMode && (
				<TabStripTab title={t("role_object_rights_tabs.others_tab")}>
					<Scrollable>
						<OthersRights {...props} organization={organization} />
					</Scrollable>
				</TabStripTab>
			)}
		</TabStrip>
	);
}

export default RightsBasedOnEntity;
